import React from "react";
import { Table, Button } from "antd";

import { getCountryNameByCode } from "utils/utils";
import OriginatorInformationPanel from "components/OriginatorInformationPanel";
import EmptyIcon from "icons/EmptyIcon";
import OriginatorModal from "components/modal/OriginatorModal";
import {getBeneficiaryById, getIdType, getIndustryCode, saveOriginator} from "api/api";
import { displayGenericError } from "common/notifications";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";

import "./OriginatorsTable.scss";
import {getCountryList, getOriginatorById, getRelationshipCode} from "../api/api";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import BeneficiarySelectionComponent from "./BeneficiarySelectionComponent";
import OriginatorSelectionComponent from "./OriginatorSelectionComponent";

class OriginatorsTable extends React.Component {
  state = {
    expandedRowKeys: [],
    isOriginatorModalVisible: false,
    countries:[],
    relations:[],
    width: '0'
  };

  componentDidMount() {
    getRelationshipCode().then(response => {
      this.setState({
        relations: response
      });
    }).catch(error => {
      displayGenericError(error);
    });
    getCountryList()
      .then(response => {
        this.setState({
          countries: response
        });
      })
      .catch(error => {
        displayGenericError(error);
      });
    getIdType().then(response => {
      this.setState({
        idTypes: response
      });
    }).catch(error => {
      displayGenericError(error);
    });
    getIndustryCode().then(response => {
      this.setState({
        industries: response
      });
    }).catch(error => {
      displayGenericError(error);
    });
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));

  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  onRowClicked = (originator, idx) => {
    let newExpandedRowKeys = this.state.expandedRowKeys;
    if (newExpandedRowKeys.includes(originator.id)) {
      var index = newExpandedRowKeys.indexOf(originator.id);
      if (index !== -1) {
        newExpandedRowKeys.splice(index, 1);
      }
    } else {
      newExpandedRowKeys.push(originator.id);
    }
    this.setState({
      expandedRowKeys: newExpandedRowKeys
    });
  };

  submitOriginator = originator => {
    this.closeOriginatorModal();
    if (this.props.onRefresh) this.props.onRefresh();
  };

  onAddOriginatorClicked = () => {
    this.setState({
      isOriginatorModalVisible: true
    });
  };

  closeOriginatorModal = () => {
    this.setState({
      isOriginatorModalVisible: false,
      selectedOriginator: null
    });
  };

  editOriginatorClicked = (originatorId) => {
    getOriginatorById(originatorId)
        .then(response => {
          this.setState({
            isLoading: false,
            selectedOriginator: response,
            isOriginatorModalVisible: true

          })
        })
        .catch(error => {
          this.setState({
            isLoading: false
          });
          displayGenericError(error);
        });

  };

  updateSelectedOriginator = selectedOriginator => {
    this.setState({
      selectedOriginator: selectedOriginator
    })
  }

  render() {
    const intl = this.props.useIntl;
    let columns = [
      {
        title: intl.formatMessage({id: "app.table.originatorstable.sendername"}),
        width: 200,
        dataIndex: "displayName",
        key: "displayName"
      },
      {
        title: intl.formatMessage({id: "app.table.originatorstable.sendertype"}),
        width: 200,
        dataIndex: "originatorType",
        key: "originatorType"
      },
      //{ title: "Email", width: 200, dataIndex: "email", key: "email"},
      {
        title: intl.formatMessage({id: "app.table.originatorstable.incorporatedcountry"}),
        width: 200,
        dataIndex: "countryIncorporatedName",
        key: "countryIncorporatedName"
      },
      {
        title: intl.formatMessage({id: "app.table.originatorstable.referencenumber"}),
        width: 200,
        dataIndex: "referenceNumber",
        key: "referenceNumber"
      },
      (this.props.currentCustomer.enableVaLegs && (this.props.currentCustomer.enableVaLegs.includes("ORIGINATOR") || this.props.currentCustomer.enableVaLegs.includes("BENEFICIARY"))) ? {
        title: intl.formatMessage({id: "app.common.virtualaccount"}),
        width: 200,
        dataIndex: "virtualAccounts",
        key: "virtualAccounts",
        render: virtualAccounts => {
          if(!virtualAccounts || virtualAccounts.length == 0) {
            return (<><div></div></>)
          } else  {
            let result = [];
            virtualAccounts.map(item => {
              
              let location = '';
              if(item.virtualAccountChannelCode=='DBS_HK' ) {
                location ="(HK)"
              } else if (item.virtualAccountChannelCode=='DBS_SG') {
                location ="(SG)"
              } else if (item.virtualAccountChannelCode=='SAHABAT_SAMPOERNA') {
                location ="(ID)"  
              } else if (item.virtualAccountChannelCode=='FLASH_FX') {
                location ="(AU)"  
              }  

              if (item.virtualAccountStatus === 'UNVERIFIED') {
                result.push(<div>{item.virtualAccountStatus}</div>);
              } else {
                result.push(<div>{item.virtualAccountNumber} {location}</div>);
              }
            })
            return (<>{result}</>);
          }
        }
      } : {width: 0},
    ];
    const isMobile = this.state.width <= 767;
    if (isMobile) {
      columns = [
        {
          title: intl.formatMessage({id: "app.table.originatorstable.name"}),
          dataIndex: "fullName",
          key: "fullName"
        },
        {
          title: intl.formatMessage({id: "app.table.originatorstable.type"}),
          dataIndex: "originatorType",
          key: "originatorType"
        },
        {
          title: intl.formatMessage({id: "app.table.originatorstable.bankcountry"}),
          dataIndex: "countryIncorporatedName",
          key: "countryIncorporatedName"
        },
        {
          title: intl.formatMessage({id: "app.table.originatorstable.reference"}),
          dataIndex: "referenceNumber",
          key: "referenceNumber"
        }
      ];
    } 
    const { data } = this.props;
    return (
      <div className={"manage-originator-page"}>
        <OriginatorModal
          visible={this.state.isOriginatorModalVisible}
          onCompleted={this.submitOriginator}
          onCancel={this.closeOriginatorModal}
          selectedOriginator={this.state.selectedOriginator}
          idTypes={this.state.idTypes}
          industries={this.state.industries}
          mode={this.state.selectedOriginator ? "edit" : "new"}
          updateSelectedOriginator={ (newOriginator) => this.updateSelectedOriginator(newOriginator)}
          currentCustomer={this.props.currentCustomer}
        />
        {data && data.length > 0 && (
          <>
            <div className={"headline-page"} style={{justifyContent:'space-between'}}>
              <OriginatorSelectionComponent onChange={e=>{}}
                                             onSelected={beneficiary => this.props.onOriginatorSearch(beneficiary)}
                                             onClear={() => {
                                               this.props.onRefresh(1);
                                             }}/>
              {(this.props.currentUser && !this.props.currentUser.role.readOnly &&
                  <Button
                      htmlType={"button"}
                      type="primary"
                      onClick={this.onAddOriginatorClicked}
                  >
                    <FormattedMessage id="app.table.originatorstable.addnewsender"/>
                  </Button>
              )}
            </div>
            <Table
              expandIconAsCell={false}
              expandIconColumnIndex={-1}
              expandedRowKeys={this.state.expandedRowKeys}
              className="bp-table bp-expandable-table originators-table"
              pagination={this.props.pagination}
              onChange={this.props.onChangePage}
              expandedRowRender={(originator,idx,indent,expanded) =>
              {
                let industry = this.state.industries.find(item => item.code==originator.industry);
                let industryName = "";
                if(industry) {
                  industryName = industry.value;
                }

                return (
                <OriginatorInformationPanel
                  {...this.props}
                  originator={originator}
                  idTypes={this.state.idTypes}
                  currentCustomer={this.props.currentCustomer}
                  industryName={industryName}
                  onDeleteOriginatorClicked={this.props.onDeleteOriginatorClicked}
                  idxOfCurrentOrg = {idx}
                  updateOriginator={(idx,newOrg) => this.props.updateOriginator(idx,newOrg)}
                  edit={this.editOriginatorClicked}
                />
              )}
              }
              columns={columns}
              onRowClick={this.onRowClicked}
              dataSource={this.props.data}
              onRow={originator => {
                return (
                  this.state.expandedRowKeys.includes(originator.id) && {
                    className: "expanded-row"
                  }
                );
              }}
              loading={this.props.isLoading}
              rowKey="id"
            />
          </>
        )}
        {data && data.length === 0 && (
          <div className="originators-table-empty-wrapper">
            <EmptyIcon />
            <div className="originators-table-empty-desc">
              <FormattedMessage id="app.message.originatorstable.donthavesender"/>
            </div>
            <div className="originators-table-empty-desc">
              <FormattedMessage id="app.message.originatorstable.startaddingsender"/>
            </div>
            {(this.props.currentUser && !this.props.currentUser.role.readOnly &&
                <Button
                    htmlType={"button"}
                    type="primary"
                    className="originators-table-add"
                    onClick={this.onAddOriginatorClicked}
                >

                  <FormattedMessage id="app.table.originatorstable.addnewsender"/>
                </Button>
            )}

          </div>
        )}
      </div>
    );
  }
}


const mapStateToProps = state =>{
  return {
    currentUser: state.user.currentUser
  }
}

const mapDispatchToProps = dispatch =>{

}

export default withRouter(
    connect(mapStateToProps,mapDispatchToProps) (
        withUseIntl(OriginatorsTable)));

// export default withUseIntl(OriginatorsTable);